<button nz-button nzSize="large" [nzBlock]="fullSize" (click)="openAddPhotoModal()">
  <i nz-icon nzType="camera" nzTheme="fill"></i>
  <span *ngIf="fullSize">
    {{ 'ADD_PHOTO' | translate }}
  </span>
</button>
